import React from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const testimonials = [
  {
    name: 'Layne Oissa',
    role: '940 pontos na redação do ENEM',
    achievement: 'Aprovada em Direito - UFMT (1ª chamada)',
    image: 'https://imgur.com/1xX2L7Y.png',
    content: 'Ela me ajudou a tirar 940 na redação do Enem e esse foi meu diferencial para que me permitisse ser aprovada na 1ª chamada do curso de Direito na UFMT.',
  },
  {
    name: 'Luana Cosme',
    role: 'Evolução de 580 para 900 pontos',
    achievement: 'Superação no ENEM',
    image: 'https://imgur.com/5rtffzN.png',
    content: 'Quando vi os 900 na redação do Enem, sabendo que no último eu tinha tirado 580, eu não sabia se chorava ou pulava de tanta alegria!',
  },
  {
    name: 'Graziela Nascimento',
    role: 'Do zero à aprovação',
    achievement: 'Aprovada em Medicina',
    image: 'https://imgur.com/xoCoHs8.png',
    content: 'Eu comecei a estudar totalmente do ZERO, sem conseguir produzir nada, mas, através dos métodos da Prof. Isa, eu consegui melhorar demais e, muito mais rápido do que sonhei, PASSEI EM MEDICINA!!!',
  },
  {
    name: 'Mais Depoimentos',
    role: 'Histórias inspiradoras',
    achievement: 'Conquistas extraordinárias',
    image: 'https://imgur.com/8HOPCxv.png',
    content: 'Descubra mais histórias de alunos que transformaram seus sonhos em realidade com o Método PDTE.',
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-secondary/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Histórias de Sucesso
          </h2>
          <p className="text-xl text-primary/80 max-w-3xl mx-auto">
            Conheça algumas das transformações que o Método PDTE proporcionou na vida de nossos alunos.
          </p>
        </div>

        <div className="relative">
          <div className="absolute inset-y-0 left-0 z-10 flex items-center">
            <button className="swiper-button-prev-custom -ml-4 lg:-ml-8 w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg text-primary hover:text-accent transition-colors">
              <ChevronLeft className="h-6 w-6" />
            </button>
          </div>
          
          <div className="absolute inset-y-0 right-0 z-10 flex items-center">
            <button className="swiper-button-next-custom -mr-4 lg:-mr-8 w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-lg text-primary hover:text-accent transition-colors">
              <ChevronRight className="h-6 w-6" />
            </button>
          </div>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet !bg-accent',
              bulletActiveClass: 'swiper-pagination-bullet-active !bg-accent',
            }}
            navigation={{
              prevEl: '.swiper-button-prev-custom',
              nextEl: '.swiper-button-next-custom',
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                centeredSlides: false,
              },
              1024: {
                slidesPerView: 3,
                centeredSlides: false,
              },
            }}
            className="py-8"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow h-full">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-b from-primary/50 to-primary/80" />
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-64 object-cover"
                    />
                    <div className="absolute bottom-4 left-4 right-4 text-white">
                      <h3 className="text-xl font-bold">{testimonial.name}</h3>
                      <p className="text-white/90 text-sm">{testimonial.achievement}</p>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center mb-4">
                      <Quote className="h-8 w-8 text-accent/20" />
                      <div className="ml-2">
                        <p className="text-primary/70 font-medium">{testimonial.role}</p>
                      </div>
                    </div>
                    
                    <div className="flex mb-4">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="h-5 w-5 text-accent fill-current" />
                      ))}
                    </div>
                    
                    <p className="text-primary/80 italic">"{testimonial.content}"</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-block px-8 py-4 bg-accent text-white rounded-full text-lg font-semibold hover:bg-accent-dark transition-colors"
          >
            Comece Sua História de Sucesso
          </a>
        </div>
      </div>

      <style>{`
        .swiper-pagination {
          position: relative;
          margin-top: 2rem;
        }
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          margin: 0 6px;
        }
      `}</style>
    </section>
  );
};

export default Testimonials;